import { FC } from "react";
import { Skeleton, Stack, Typography, styled } from "@mui/material";
import { Menstruation } from "../../types";
import { DateTime } from "luxon";
import AddMenstruationCard from "./AddMenstruationCard";
import MenstruationCard from "./MenstruationCard";

const LoadingCard = styled(Skeleton)({
  height: "3rem",
  margin: "0.5rem 0",
});

interface MenstruationsProps {
  menstruationsLoaded: boolean;
  menstruations: Menstruation[];
  addMenstruation: (newMenstruation: {
    startDate: DateTime;
    endDate: DateTime;
  }) => void;
  editMenstruation: (
    menstruationId: number,
    newMenstruation: { startDate: DateTime; endDate: DateTime },
  ) => void;
  deleteMenstruation: (menstruationId: number) => void;
}

const Menstruations: FC<MenstruationsProps> = ({
  menstruationsLoaded,
  menstruations,
  addMenstruation,
  editMenstruation,
  deleteMenstruation,
}) => (
  <Stack spacing={1}>
    <Stack direction="row" justifyContent="space-between">
      <Typography variant="h6">Menstruations</Typography>
      <AddMenstruationCard addMenstruation={addMenstruation} />
    </Stack>
    {!menstruationsLoaded ? (
      <>
        <LoadingCard variant="rounded" />
        <LoadingCard variant="rounded" />
        <LoadingCard variant="rounded" />
      </>
    ) : menstruations.length ? (
      <>
        {menstruations.map((menstruation) => (
          <MenstruationCard
            key={menstruation.menstruationId}
            menstruation={menstruation}
            editMenstruation={editMenstruation}
            deleteMenstruation={deleteMenstruation}
          />
        ))}
      </>
    ) : (
      <Typography textAlign="center">
        This patient has no recorded menstruations.
      </Typography>
    )}
  </Stack>
);

export default Menstruations;
